<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <!-- <div class="card card-custom card-stretch gutter-b">-->
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column"></h3>
          <div class="card-toolbar"></div>
        </div>

        <b-row class=" mt-10 ml-5 mr-5">
          <b-col sm="7">
            <b-form-group>
              <b-input-group size="sm">
                <b-form-select v-model="selected" :options="options" @change="fetchData"></b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-button variant="primary" class="float-right" style="padding-top: 6px; padding-bottom: 6px"
              v-on:click.prevent="openForm(-1)">
              {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
            </b-button>
          </b-col>
        </b-row>
        <div class="card-body pt-0 pb-3 mt-4">
          <div class="tab-content">
            <div class="table-responsive">

              <b-table id="organizations-table" :striped="false" :items="items" :fields="fields" :no-sort-reset="true"
                :busy.sync="isBusy" :loading="false" :borderless="true" head-variant="light" :no-local-sorting="true"
                @sort-changed="sortChange" :per-page="perPage" :current-page="currentPage">

                <template #cell(action)="data">
                  <a href="javascript:" @click="openForm(data.item.id)" class="btn btn-icon btn-light btn-sm"
                    v-b-tooltip.hover :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')">
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <inline-svg src="media/svg/icons/General/Edit.svg"></inline-svg>
                    </span> </a>&nbsp;&nbsp;&nbsp;
                    <a href="javascript:" @click.prevent="removeData(data.item.id)" class="btn btn-icon btn-light btn-sm"
                    v-b-tooltip.hover :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE')">
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>
                    </span>
                  </a>
                </template>
              </b-table>
              <p class="text-center pt-3" v-if="items.length < 1">
                {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
              </p>
            </div>
            <div class="row justify-content-between">
              <div div class="col-lg-2">
                <b-form-group id="name-input-group" :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')" label-for="name-input"
                  label-cols="7" label-align-sm="left" label-size="lg">
                  <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="paginationOptions">
                  </b-form-select>
                </b-form-group>
              </div>
              <div div class="col-lg-2">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="my-table">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
     <!--  </div> -->
    </div>
    <div>
      <b-modal :id="PointsCouldModalName" size="xl" :hide-header="true" :hide-footer="true" :centered="true"
        @show="onShow()" @hide="onHide()">
        <div class="row mt-5">
          <div class="col-lg-12">
            <b-form @submit.stop.prevent="onSubmit()">
              <b-row class="mb-5 row d-flex justify-content-center">
                <b-col sm="3">
                  <label>
                    <h3>{{ $t("PAGE.POINTS_COULD.FORM.FIELDS.NAME_FORM") }} </h3>
                  </label>
                </b-col>
              </b-row>

              <b-row class="mb-5 row d-flex justify-content-center">
                <b-col sm="10">
                  <label>
                    <h5>
                      {{ $t("PAGE.POINTS_COULD.FORM.FIELDS.TYPE") }}
                    </h5>
                  </label>
                  <b-form-select v-if="pointsCouldId == -1" v-model="$v.form.points_could_type.$model" class="mb-3"
                    disabled-field="notEnabled" :state="validateState('points_could_type')"
                    aria-describedby="points_could_type-live-feedback" @input="getPointsCouldOriginal">
                    <option v-for="item in optionsModal" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </option>
                  </b-form-select>
                  <b-form-select v-if="pointsCouldId > -1" disabled v-model="$v.form.points_could_type.$model"
                    class="mb-3" disabled-field="notEnabled" :state="validateState('points_could_type')"
                    aria-describedby="points_could_type-live-feedback" @input="getPointsCouldOriginal">
                    <option v-for="item in optionsModal" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </option>
                  </b-form-select>

                  <b-form-invalid-feedback id="points_could_type-live-feedback">
                    <span v-if="!$v.form.points_could_type.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>

              </b-row>

              <b-row class="mb-5  row d-flex justify-content-center" v-if="form.points_could_type == 1">
                <b-col sm="10">
                  <label>
                    <h5>
                      {{ $t("PAGE.POINTS_COULD.FORM.FIELDS.DATE") }}
                    </h5>
                  </label>
                  <datepicker v-model="date" :bootstrap-styling="true" :language="getLanguage()"
                    :format="'dd MMMM yyyy'">
                  </datepicker>
                </b-col>

              </b-row>
              <b-row class="mb-5  row d-flex justify-content-center" v-if="form.points_could_type == 2">
                <b-col sm="5">
                  <label>
                    <h5>

                      {{ $t("PAGE.POINTS_COULD.FORM.FIELDS.DATE") }}
                    </h5>
                  </label>
                  <b-form-select v-model="$v.form.original_1.$model" class="mb-3" disabled-field="notEnabled"
                    :state="validateState('original_1')" aria-describedby="points_could_type-live-feedback">
                    <option v-for="item in optionsOriginal" :key="item.id" :value="item.id">
                      {{ item.date }}
                    </option>
                  </b-form-select>

                </b-col>
                <b-col sm="5">
                  <label>
                    <h5>
                      {{ $t("PAGE.POINTS_COULD.FORM.FIELDS.DATE") }}
                    </h5>
                  </label>
                  <b-form-select v-model="$v.form.original_2.$model" class="mb-3" disabled-field="notEnabled"
                    :state="validateState('original_2')" aria-describedby="original_2-live-feedback">
                    <option v-for="item in optionsOriginal" :key="item.id" :value="item.id">
                      {{ item.date }}
                    </option>
                  </b-form-select>

                </b-col>
              </b-row>
              <b-row class="mb-5  row d-flex justify-content-center" v-if="form.points_could_type == 2">
                <b-col sm="5">
                  <label>
                    <h5>
                      ค่า min (เมตร)
                    </h5>
                  </label>
                  <b-form-input v-model="$v.form.min.$model" placeholder="Enter value min"
                  :state="validateState('min')" aria-describedby="original_2-live-feedback"></b-form-input>

                </b-col>
                <b-col sm="5">
                  <label>
                    <h5>
                      ค่า max (เมตร)
                    </h5>
                  </label>
                  <b-form-input v-model="$v.form.max.$model" placeholder="Enter value max"
                  :state="validateState('max')" aria-describedby="original_2-live-feedback"></b-form-input>


                </b-col>
              </b-row>
              <b-row class="mb-5  row d-flex justify-content-center">
                <b-col sm="10">
                  <label>
                    <h5>
                      {{ $t("PAGE.POINTS_COULD.FORM.FIELDS.DOC_FILE") }}
                    </h5>
                  </label>
                  <b-form-file id="fileupload" name="fileupload" type="file" :placeholder="file_name"
                    v-model="$v.form.fileupload.$model" @change="reset_percent($event)"></b-form-file>
                  <span v-if="fileupload_required == true" class="RequiredColor">
                    {{ $t("PAGE.DEFAULT.FORM.VALIDATION.UPLOAD") }}
                  </span>
                  <b-progress :max="100" class="mt-2">
                    <b-progress-bar :value="percent" :label="`${percent}%`"></b-progress-bar>
                  </b-progress>

                  <b-button class="float-left mt-2" @click="upload()">Upload File</b-button>

                  <div v-if="file_path">
                    <b-button class="float-left ml-3 mt-2" @click="preview_file()">Preview</b-button>
                  </div>
                </b-col>

              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-button class="float-right" @click.prevent="cancel()">{{
                      $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                  }}</b-button>
                  <b-button type="submit" variant="primary" class="float-right mr-3">{{
                      $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
                  }}</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-modal>

    </div>
  </div>
</template>

<style>
.b-table th {
  background-color: #840000 !important;
  color: #ffff !important;
}

.location-container {
  width: 90%;
}

.location-map {
  width: 100%;
  height: 500px;
  border-radius: 4px;
  border: 1px solid #fff;
}

.idField {
  min-width: 100px;
  width: 10%;
  max-width: 100px;
}

.fullNameField {
  min-width: 100px;
  width: 30%;
  max-width: 100px;
}

.emailField {
  min-width: 100px;
  width: 40%;
  max-width: 100px;
}

.actionField {
  min-width: 100px;
  width: 45%;
  max-width: 100px;
}

.actionField {
  min-width: 100px;
  width: 10%;
  max-width: 100px;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import {
  PAGINATION_POINTS_COULD_DATA,
  SET_IS_CLEAR_PAGINATION,
  SET_PAGINATION,
  CLEAR_PAGINATION,
  DELETE_POINTS_COULD_DATA
} from "@/core/services/store/points_could.module";
import { mapState } from "vuex";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import { en, th } from "vuejs-datepicker/dist/locale";
import {
  POST_POINTS_COULD_ORIGINAL_DATA,
  LIST_POINTS_COULD_ORIGINAL_SELECT_DATA,
  PUT_POINTS_COULD_ORIGINAL_DATA
} from "@/core/services/store/points_could_original.module";
import {
  POST_POINTS_COULD_DIFFERENT_DATA,
  PUT_POINTS_COULD_DIFFERENT_DATA
} from "@/core/services/store/points_could_different.module";
import { GET_POINTS_COULD_FORM_DATA } from "@/core/services/store/points_could.module";
import axios from "axios";
export default {
  components: {
    Datepicker
  },
  mixins: [validationMixin],
  data() {
    return {
      perPage: 25,
      currentPage: 1,
      selected: 1,
      options: [
        { value: 1, text: 'ทั้งหมด' },
        { value: 'Original', text: 'Original' },
        { value: 'Different', text: '	Different' },
      ],
      fields: [
        {
          key: "name_product",
          label: `${this.$t("PAGE.POINTS_COULD.FORM.FIELDS.DETAIL")}`,
          key_table: "id",
          sortable: true,
          isFilter: false,
          tdClass: "emailField"
        },

        {
          key: "name",
          label: `${this.$t("PAGE.POINTS_COULD.FORM.FIELDS.TYPE")}`,
          key_table: "name",
          sortable: true,
          isFilter: false,
          tdClass: "fullNameField"
        },
        {
          key: "action",
          label: `${this.$t("PAGE.POINTS_COULD.FORM.FIELDS.ACTION")}`,
          sortable: false,
          isFilter: false,
          tdClass: "actionField"
        }
      ],
      select: ["id", "points_could_different_id", "points_could_original_id"],
      paginationOptions: [25, 50, 100, 200],
      include: ["pointsCouldDifferent", "pointsCouldOriginal"],

      isBusy: false,
      items: [],
      total: 0,
      pointsCouldId: -1,
      PointsCouldModalName: "bv-modal-points-could",
      mangroveLocationId: null,
      //modal
      date: new Date(),
      isSubmit: false,
      id_original: 0,
      // File things
      percent: 0,
      file_name: "Upload before sumitting",
      file_path: "",
      is_file_no_update: true,
      fileupload_required: false,

      form: {
        points_could_type: 1,
        fileupload: "",
        original_1: "",
        original_2: "",
        min:'',
        max:''
      },
      table: {
        items: [],
      },
      trashData: [],
      manageTypeData: [],
      optionsModal: [{ name: 'Original', id: 1 }, { name: 'Different', id: 2 }],
      optionsOriginal: []
    };
  },
  validations: {
    isSubmitForm: false,
    form: {
      original_1: {},
      original_2: {},
      fileupload: {},
      min:{},
      max:{},
      points_could_type: { required },
    },
  },
  computed: {
    rows() {
      return this.items.length
    },
    ...mapState({
      userType: state => state.auth.userType
    }),
    isClearPagination: {
      get() {
        return this.$store.state.user.isClearPagination;
      },
      set(value) {
        this.$store.commit(SET_IS_CLEAR_PAGINATION, {
          isClearPagination: value
        });
      }
    },
    pagination: {
      get() {
        return this.$store.state.user.pagination;
      },
      set(value) {
        this.$store.commit(SET_PAGINATION, { pagination: value });
      }
    }
  },
  mounted() {

    this.mangrove_location_id = this.$route.params.id
    if (this.mangrove_location_id > 0) {
      this.fetchData();
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: `${this.$t("MENU.MANGROVE_INFO.NAME")}` }
    ]);
    if (this.isClearPagination) {
      this.$store.commit(CLEAR_PAGINATION);
    }
    this.isClearPagination = true;
  },
  methods: {
    // table
    openForm(item) {
      if (this.mangrove_location_id > 0) {
        this.mangroveLocationId = this.mangrove_location_id
      }
      else {
        this.mangroveLocationId = this.$store.state.mangrove_location.data_pram.mangrove_location_id
      }
      this.pointsCouldId = item

      setTimeout(() => {
        this.$bvModal.show(this.PointsCouldModalName);
      }, 50);
    },
    sortChange(event) {
      this.pagination.isDesc = event.sortDesc;
      this.pagination.orderBy = event.sortBy;
      this.fetchData();
    },
    getParams() {
      if (this.mangrove_location_id == undefined) {
        this.mangrove_location_id = this.$store.state.mangrove_location.data_pram.mangrove_location_id
      }
      return {
        mangrove_location_id: this.mangrove_location_id,
        selected: this.selected,
        page: this.pagination.page.toString(),
        perPage: this.pagination.perPage.toString(),
        isDesc: this.pagination.isDesc.toString(),
        filter: this.pagination.filter.toString(),
        filterBy: `${this.fields
          .map(item => {
            if (item.isFilter) return item.key;
          })
          .filter(item => !!item)}`,
        select: `${this.select}`,
        include: `${this.include}`
      };
    },
    fetchData() {
      this.$store
        .dispatch(PAGINATION_POINTS_COULD_DATA, { params: this.getParams() })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data;
            this.total = data.data.total;
            if (this.total > 0 && this.items.length < 1) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
              confirmButtonColor: '#840000'
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            confirmButtonColor: '#840000'
          });
          this.isBusy = false;
        });
    },

    removeData(id) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`,
        confirmButtonColor: '#840000'
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DELETE_POINTS_COULD_DATA, { id })
            .then(({ data }) => {
              if (data.status === "success") {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.fetchData();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
              this.isBusy = false;
            })
            .catch(error => {
              Swal.fire({
                icon: "error",
                text: `${error.error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
              this.isBusy = false;
            });
        }
      });
    },

    //MODAL
    cancel() {
      this.$bvModal.hide(this.PointsCouldModalName)
      this.onHide();
    },
    getPointsCouldOriginal() {
      this.optionsOriginal = []
      if (this.form.points_could_type == 2) {
        this.$store
          .dispatch(LIST_POINTS_COULD_ORIGINAL_SELECT_DATA, { params: { mangrove_location_id: this.mangroveLocationId } })
          .then(({ data }) => {
            if (data.status === "success" && data.data) {
              let data_select = data.data
              for (let info of data_select) {
                let date = new Date(info.date).toLocaleString("af-ZA", {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                });
                this.optionsOriginal.push({ date: date, id: info.id })
              }
              //console.log(this.optionsOriginal);
            } else if (data.status === "error" && data.error) {
              Swal.fire({
                icon: "error",
                text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              text: `${error}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
              confirmButtonColor: '#840000'
            });
          })
      }
    },
    reset_percent() {
      this.percent = 0;
      this.file_path = "";
      this.is_file_no_update = true;
    },
    upload() {
      this.percent = 0;
      var _this = this;
      var elmnt = this.form.fileupload;
      if (elmnt != "") {
        var fd = new FormData();
        fd.append("fileupload", elmnt);
        axios
          .post(`${process.env.VUE_APP_API}/points_could/fileupload`, fd, {
            onUploadProgress: function (uploadEvent) {
              _this.percent = Math.round(
                (uploadEvent.loaded / uploadEvent.total) * 100
              );
            }
          })
          .then(function (res) {
            _this.file_path = res.data.file_path;
            _this.fileupload_required = false;
          })
          .catch(function (e) {

            alert(e);
          });
      }
    },
    preview_file() {
      window.open(`${process.env.VUE_APP_IMAGE}` + this.file_path);
    },
    getLanguage() {
      switch (this.$i18n.locale) {
        case "th":
          return th;
        case "en":
          return en;
        default:
          return th;
      }
    },
    onShow() {
      this.isSubmit = false;
      this.$v.$reset();

      if (this.pointsCouldId > -1) {
        this.get(this.pointsCouldId);
      }
    },
    onHide() {
      this.file_name = "Upload before sumitting";
      this.reset_percent()
      this.form.points_could_type = 1;
      this.form.original_1="";
      this.form.original_2="";
      this.form.min="";
      this.form.max="";
      this.date = new Date();
      this.$v.$reset();
      this.optionsOriginal=[];
      this.isSubmit = false;
      this.fetchData()

    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    get(id) {
      this.$store
        .dispatch(GET_POINTS_COULD_FORM_DATA, { id })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            for (const formKey of Object.keys(this.form)) {
              for (const dataKey of Object.keys(data.data)) {
                if (formKey === dataKey) {
                  this.form[formKey] = data.data[formKey];
                }
              }
            }
            this.date = new Date(data.data.date).toLocaleString("en-US", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            });
            this.file_name = `${data.data["csv"]}`;
            this.file_path = `${data.data["csv"]}`;
            this.is_file_no_update = false;

            this.id_original = data.data.id
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
              confirmButtonColor: '#840000'
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
            confirmButtonColor: '#840000'
          });
        })
    },


    onSubmit() {
      this.isSubmit = true;
      // Check file upload before submit
      if (
        (this.form.fileupload == "" || this.file_path == "") &&
        this.is_file_no_update
      ) {
        this.fileupload_required = true;
        return;
      }

      if (this.form.points_could_type == 2) {
        let formData = new FormData();
        formData.append("original_1", this.form.original_1);
        formData.append("original_2", this.form.original_2);
        formData.append("csv", this.file_path);
        formData.append("max", this.form.max);
        formData.append("min", this.form.min);
        formData.append("mangrove_location_id", this.mangroveLocationId);
        if (this.pointsCouldId > -1) {
          this.updatePointsCouldDifferent(this.id_original, formData);
        } else {
          this.createPointsCouldDifferent(formData);
        }
      }
      else {
        let date = new Date(this.date).toLocaleString("en-US", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });

        let formData = new FormData();
        formData.append("date", date);
        formData.append("csv", this.file_path);
        formData.append("mangrove_location_id", this.mangroveLocationId);
        if (this.pointsCouldId > -1) {
          this.updatePointsCouldOriginal(this.id_original, formData);
        } else {
          this.createPointsCouldOriginal(formData);
        }
      }
    },
    createPointsCouldOriginal(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_POINTS_COULD_ORIGINAL_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `สร้างข้อมูลเรียบร้อยแล้ว`,
                  confirmButtonColor: '#840000'
                });
                this.$bvModal.hide("bv-modal-points-could");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t(data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    createPointsCouldDifferent(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_POINTS_COULD_DIFFERENT_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `สร้างข้อมูลเรียบร้อยแล้ว`,
                  confirmButtonColor: '#840000'
                });
                this.$bvModal.hide("bv-modal-points-could");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    updatePointsCouldOriginal(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_POINTS_COULD_ORIGINAL_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$bvModal.hide("bv-modal-points-could");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t(data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    updatePointsCouldDifferent(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_POINTS_COULD_DIFFERENT_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$bvModal.hide("bv-modal-points-could");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
